<template>
  <header class="header">
    <div class="left-side">
      <router-link
        class="navbar-brand"
        to="/"
        @click.prevent="resetHome"
      >
        <img
          id="img-navbar"
          src="@/assets/logoGex1.2.png"
          alt="GEX"
        />
      </router-link>

      <ul class="navbar-nav">
        <li id="creditos">
          <h6>Universidade Federal do Ceará</h6>

          <h4>
            <a
              id="link"
              href="https://prex.ufc.br/pt/"
              target="_blank"
              rel="noopener noreferrer"
            >
              PRÓ-REITORIA DE EXTENSÃO
            </a>
          </h4>
        </li>
      </ul>
    </div>

    <div class="right-side">
      <div class="desktop-menu">
        <MenuNavegacao />
      </div>

      <div
        class="user-icon"
        @click="abrirMenuUsuario"
      >
        <i
          v-if="!imagemPerfil"
          class="fas fa-user-circle"
        ></i>

        <img
          v-else
          :src="imagemPerfil"
          alt="Perfil"
          class="imagem-perfil"
        />
      </div>

      <button
        class="menu-hamburguer"
        type="button"
        aria-label="Abrir menu"
        :aria-expanded="menuMobileAberto"
        @click="alternarMenuMobile"
      >
        <i class="fas fa-bars"></i>
      </button>
    </div>
  </header>

  <Transition name="menu-mobile">
    <div
      v-if="menuMobileAberto"
      class="mobile-menu-overlay"
    >
      <div class="mobile-menu-header">
        <button
          class="mobile-menu-fechar"
          type="button"
          aria-label="Fechar menu"
          @click="fecharMenuMobile"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <MenuNavegacao
        mobile
        @fechar-menu="fecharMenuMobile"
      />
    </div>
  </Transition>

  <MenuLateralPerfilUsuario
    ref="menuRef"
    @fechou="menuAberto = false"
  />
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { storeToRefs } from "pinia";

import MenuLateralPerfilUsuario from "./MenuLateralPerfilUsuario.vue";
import MenuNavegacao from "./MenuNavegacao.vue";
import usuariosService from "@/service/usuariosService";

const imagemPerfil = ref("");

const router = useRouter();
const authStore = useAuthStore();

const { userScope, estaRenovando } = storeToRefs(authStore);

const menuAberto = ref(false);
const menuRef = ref(null);

function abrirMenuUsuario() {
  if (!menuRef.value) return;

  if (menuAberto.value) {
    menuRef.value.closeMenu();
    menuAberto.value = false;
  } else {
    menuRef.value.openMenu();
    menuAberto.value = true;
  }
}

const menuMobileAberto = ref(false);

function alternarMenuMobile() {
  menuMobileAberto.value = !menuMobileAberto.value;
}

function fecharMenuMobile() {
  menuMobileAberto.value = false;
}

watch(menuMobileAberto, (aberto) => {
  document.body.style.overflow = aberto ? "hidden" : "";
});

function resetHome() {
  router.push("/");
  fecharMenuMobile();
}

onMounted(async () => {
  const token = authStore.accessToken;

  if (token) {
    const response = await usuariosService.getUsuarioLogado();

    imagemPerfil.value = response?.imagemUrl || "";
  }
});

watch(
  () => authStore.accessToken,
  (newToken) => {
    if (!newToken) {
      imagemPerfil.value = "";
    }
  }
);

onBeforeUnmount(() => {
  document.body.style.overflow = "";
});
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 101;
  height: 90px;
  padding: 1rem 1.5rem;
  position: sticky;
  top: 0;
  width: 100%;
  background: linear-gradient(135deg, #3b1f8c 0%, #5a35c8 60%, #7b4fe0 100%);
  box-sizing: border-box;
}

.left-side {
  display: flex;
  align-items: center;
  min-width: 0;
}

.right-side {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
}

.navbar-brand {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

#img-navbar {
  width: 120px;
  padding-right: 10px;
}

.navbar-nav {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

#creditos {
  color: white;
  margin-left: 10px;
  list-style: none;
}

#creditos h6 {
  margin: 0 0 3px;
}

#creditos h4 {
  margin: 0;
}

#link {
  font-size: 1.3rem;
  text-decoration: none;
  color: white;
}

#link:hover {
  color: #e5dbfaff;
  transition: 200ms;
}

.user-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
}

.user-icon i {
  cursor: pointer;
  font-size: 26px;
  color: white !important;
}

.user-icon i:hover {
  opacity: 0.7;
}

.imagem-perfil {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}

.menu-hamburguer {
  display: none;
  border: none;
  background: transparent;
  color: white;
  font-size: 25px;
  padding: 5px;
  cursor: pointer;
}

.mobile-menu-overlay {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100dvh;
  z-index: 9999;
  background: linear-gradient(135deg, #3b1f8c 0%, #5a35c8 60%, #7b4fe0 100%);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.mobile-menu-header {
  height: 70px;
  padding: 0.8rem 1rem;
  display: flex;
  align-items: center;
  justify-content: right;
  box-sizing: border-box;
  flex-shrink: 0;
}

.mobile-menu-titulo {
  color: white;
  font-size: 1.4rem;
  font-weight: 600;
}

.mobile-menu-fechar {
  border: none;
  background: transparent;
  color: white;
  font-size: 30px;
  cursor: pointer;
  padding: 5px;
}

.menu-mobile-enter-active,
.menu-mobile-leave-active {
  transition: transform 0.3s ease;
}

.menu-mobile-enter-from,
.menu-mobile-leave-to {
  transform: translateX(100%);
}

.menu-mobile-enter-to,
.menu-mobile-leave-from {
  transform: translateX(0);
}

@media (max-width: 768px) {
  .header {
    height: 70px;
    padding: 0.8rem 1rem;
  }

  #img-navbar {
    width: 95px;
    padding-right: 0;
  }

  #creditos {
    display: none;
  }

  .desktop-menu {
    display: none;
  }

  .right-side {
    gap: 1rem;
  }

  .user-icon i {
    font-size: 25px;
  }

  .imagem-perfil {
    width: 30px;
    height: 30px;
  }

  .menu-hamburguer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media (max-width: 380px) {
  #img-navbar {
    width: 85px;
  }

  .right-side {
    gap: 0.7rem;
  }

  .user-icon i {
    font-size: 23px;
  }

  .menu-hamburguer {
    font-size: 23px;
  }
}
</style>
